import { createApp } from "vue";
import { createGtm } from "@gtm-support/vue-gtm";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Rollbar from "rollbar";
import mixpanel from "../api/mixpanelInstance";
import ClickyDirective from "./directives/clicky";
import format from "./utils/format";
import "./assets/style/main.scss";

const rollbar = new Rollbar({
  accessToken: process.env.POST_CLIENT_ITEM_ACCESS_TOKEN,
  captureUncaught: false,
  captureUnhandledRejections: false,
  payload: {
    environment:
      process.env.STAGING == "true" ? "staging" : process.env.NODE_ENV,
  },
});

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp(App);
  app.config.errorHandler = (err, vm, info) => {
    if (process.env.NODE_ENV === "development") {
      console.error("Vue Error:", err);
      console.error("Error Stack:", err.stack);
      console.error("Component:", vm);
      console.error("Error Info:", info);
      console.error(
        "Component Stack:",
        vm?.$options?.__file || "Unknown component"
      );
    }
    rollbar.error(err);
    // Don't throw in development to prevent browser crashes
    if (process.env.NODE_ENV === "production") {
      throw err;
    }
  };
  app.config.warnHandler = (msg, vm, trace) => {
    if (process.env.NODE_ENV === "development") {
      console.warn(`[Vue warn]: ${msg}\n${trace}`);
    }
  };
  app.config.globalProperties.$rollbar = rollbar;
  app.config.globalProperties.$mixpanel = mixpanel;
  app.config.productionTip = false;

  app.directive("clicky", ClickyDirective).use(store).use(router).mixin(format);

  try {
    app.use(
      createGtm({
        id: process.env.GA_ID,
        // Production must follow GTM's Live container. Local preview settings
        // are also passed into Docker builds and can pin it to an old version.
        queryParams:
          process.env.NODE_ENV === "production" && process.env.STAGING !== "true"
            ? {}
            : {
                gtm_auth: process.env.GA_AUTH,
                gtm_preview: process.env.GA_ENV,
                gtm_cookies_win: "x",
              },
        defer: true,
        compatibility: true,
        nonce: Math.random().toString(36).slice(2),
        enabled: true,
        debug: process.env.NODE_ENV === "development",
        loadScript: true,
        vueRouter: router,
        vueRouterAdditionalEventData: () => {
          try {
            const accountStatus =
              store.getters["sessions/user"]?.account_status_name || "New User";
            return { accountStatus };
          } catch (error) {
            console.error("Error getting account status:", error);
            return { accountStatus: "New User" };
          }
        },
        ignoredViews: [""],
        trackOnNextTick: false,
      })
    );
  } catch (error) {
    console.error("Error initializing GTM:", error);
  }

  app.mount("#app");
});
